import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
    withCredentials: true
});

export class PaymentMethodFetchAPI {

    static async getPaymentMethod(machine_id, token) {
        const res = await server(`/machine/${machine_id}/paymentmethod?status=true`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }
}